var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLanguageAra = function SvgLanguageAra(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H3C1.345 0 0 1.345 0 3v13.5c0 1.655 1.345 3 3 3h4.5v3.938a.56.56 0 0 0 .895.45L14.25 19.5H21c1.655 0 3-1.345 3-3V3c0-1.655-1.345-3-3-3m.75 16.5c0 .413-.337.75-.75.75h-7.5l-.6.45-3.15 2.363V17.25H3a.75.75 0 0 1-.75-.75V3c0-.413.337-.75.75-.75h18c.413 0 .75.337.75.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.326 11.535H5.744L5.072 13h-.98l2.984-6.41L9.955 13h-.996zm-.371-.855L7.06 8.629l-.937 2.05zm4.4-.25L14.224 13h-1.114l-1.722-2.469h-.164V13h-.91V6.969h1.066q1.195 0 1.726.449.586.5.586 1.32 0 .641-.367 1.102a1.64 1.64 0 0 1-.969.59m-1.132-.692h.289q1.293 0 1.293-.988 0-.926-1.258-.926h-.324zm7.053 1.797h-2.582L15.022 13h-.98l2.984-6.41L19.905 13h-.996zm-.371-.855-.895-2.051-.937 2.05z"
  })));
};
export default SvgLanguageAra;